import { render, staticRenderFns } from "./AdColonyIcon.vue?vue&type=template&id=f021db18&"
import script from "./AdColonyIcon.vue?vue&type=script&lang=js&"
export * from "./AdColonyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports